import './styles/main.css';
import { Experience } from './Experience';

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', () => {
  const app = document.getElementById('app');
  if (!app) return;

  // Create the experience
  const experience = new Experience(app);

  // Handle visibility change (pause/resume + wake lock)
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      experience.pause();
    } else {
      experience.resume();
      experience.handleVisibilityChange();
    }
  });

  // Handle resize
  window.addEventListener('resize', () => {
    experience.resize();
  });
});

